class FilteredPosts {
  constructor(filter) {
    this.el = filter;
    this.postCards = document.querySelectorAll('.record-card');
    //this.noResults = document.querySelector('.no-results');
    this.init();
    this.bindListeners();
  }

  filterCards(selectedMonth) {
    let matches = 0;
    this.postCards.forEach((card) => {
      const cardMonth = card.getAttribute('data-month');
      if (selectedMonth === "All") {
        card.classList.remove('hidden');
        matches++;
      } else if (cardMonth === selectedMonth || selectedMonth === "") {
        card.classList.remove('hidden');
        matches++;
      } else {
        card.classList.add('hidden');
      }
    });
    /* if (matches === 0) {
      this.noResults.classList.remove('hidden');
    }else {
      this.noResults.classList.add('hidden');
    } */
  }

  init() {
    const initialMonth = this.el.value;
    this.filterCards(initialMonth);
  }

  bindListeners() {
    this.el.addEventListener('change', (event) => {
      const selectedMonth = event.target.value;
      this.filterCards(selectedMonth);
    });
  }
}

const filter = document.getElementById('month-filter');
if (filter) {
  new FilteredPosts(filter);
}